import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { delay } from 'rxjs/operators';
import moment from 'moment';

import { BaseUI } from '../../base.ui';
import { Address, Country, FullClient } from '../../../domain/data';
import { ClientRelation, ClientType, DocumentType, GetCountriesUseCase } from '../../../../core';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';
import { ThErrorStateMatcher } from '../../../utils/error-state-matcher';

import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'thr-full-data-one-minor-disabled-person',
    templateUrl: './full-data-one-minor-disabled-person.component.html',
    styleUrls: ['./full-data-one-minor-disabled-person.component.scss'],
})
export class FullDataOneMinorDisabledPersonComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public ClientRelation: typeof ClientRelation = ClientRelation;
    public ClientType: typeof ClientType = ClientType;
    public DocumentType: typeof DocumentType = DocumentType;

    public form: NgForm;
    public isFormValid = false;
    public errorMatcher = new ThErrorStateMatcher();

    public today = moment();
    public hundredYears = moment().subtract(100, 'years');
    public countries: Country[] = [];
    public isClientPortal = environment.portalClient;

    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @Input()
    isDisabledSubmit = false;

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;

    constructor(parentEvents: ParentEvents, private dialog: MatDialog, private getCountriesUseCase: GetCountriesUseCase) {
        super(parentEvents);
    }

    ngOnInit() {
        this.getCountries();
    }

    private getCountries() {
        this.getCountriesUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.countries = transaction.data as Country[];
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = this.formDirective.controlContainer as NgForm;

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    onHabitualResidenceChange() {
        if (this.client.isEqualMailAddress) {
            this.client.mailResidence = cloneDeep(this.client.habitualResidence);
        }
    }

    onEqualMailAddressChange() {
        if (this.client.isEqualMailAddress) {
            this.client.mailResidence = cloneDeep(this.client.habitualResidence);
        } else {
            this.client.mailResidence = new Address();
        }

        this.parentEvents.resize();
    }
}
